<template>
  <div class="weight" :style="{ width: 624 + 'px', height: 263 + 'px' }">
    <form>
      <input
        type="number"
        required
        name="weight"
        max="155"
        min="0.1"
        value="0.10"
        step="0.10"
        id="weight-input-value"
        @change="updateWeight"
        ref="weightInputField"
      />
      <span class="fl-blue weight-measurement">Kg</span>
    </form>

    <div
      class="fl-sym-weight-input-container fl-sym-text-center fl-sym-select-none fl-sym-py-20 fl-sym-relative"
      ref="container"
    >
      <div class="dot" />
      <span
        class="fl-sym-h-10 fl-sym-w-1 fl-sym-bg-primary fl-sym-inline-block fl-sym-select-none fl-sym-indicator"
      >
      </span>

      <div
        class="fl-sym-flex fl-sym-weight-input fl-sym-select-none"
        ref="fl-sym-weight-input"
        v-dragged="onDragged"
        :style="{ transform: 'translateX(' + translateval + 'px)' }"
      >
        <div
          v-for="n in 1550"
          :key="n"
          class="fl-sym-select-none fl-sym-relative fl-sym-weight-input-bar"
          :class="{ 'fl-sym-h-20': n % 10 == 0, 'fl-sym-h-10': n % 10 !== 0 }"
          :style="{
            width: (n % 10 == 0 ? bigBarWidth : normalBarWidth) + 'px',
            margin: (n % 10 == 0 ? bigBarMargin : normalBarMargin) + 'px',
          }"
        >
          <div class="number" v-if="n % 10 == 0">
            {{ n / 10 }}
          </div>
        </div>
      </div>
      <div class="white-left"></div>
      <div class="white-right"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import VDragged from "v-dragged"
Vue.use(VDragged)

export default {
  data() {
    return {
      position_x: 307, //290 = 0
      moved: false,
      translateval: 0,
      maxkg: 155,
      maxslider: 0,
      value: 0.1,
      width: 0,
      normalBarMargin: 0,
      normalBarWidth: 0,
      bigBarMargin: 0,
      bigBarWidth: 0,
      totalBar: 18.15,
      style: null,
      marginleft: 0,
    }
  },
  mounted() {
    this.$refs.weightInputField.focus()
    this.marginleft = this.$refs["container"].clientWidth / 2
    this.width = 312
    this.normalBarMargin = 6
    this.normalBarWidth = 2
    this.bigBarWidth = this.normalBarWidth + 2
    this.bigBarMargin = this.normalBarMargin - 2
    this.barTotalSpace = this.normalBarMargin + this.normalBarWidth
    this.position_x = 307
    this.translateval = 307
    this.maxslider = Math.round(-138 * this.maxkg) + 320
  },
  methods: {
    onDragged(position) {
      this.moved = true
      if (position.deltaX) {
        if (
          Math.floor(this.position_x + position.deltaX) + 2.5 < this.width &&
          Math.floor(this.position_x + position.deltaX) > this.maxslider - 1
        ) {
          this.position_x = Math.floor(this.position_x + position.deltaX)
          this.value =
            (
              0.1 *
              (Math.floor(-(this.position_x - this.width) / 15) + 1)
            ).toFixed(2) + "0"
          this.translateval = this.position_x
          this.value =
            (Math.round(this.translateval - 320) / -138).toFixed(1) + "0"

          document.getElementById("weight-input-value").value = this.value
          this.$forceUpdate()
        }
      }
      if (position.last) {
        if ((this.width / 7.5) % 2 == 0) {
          if (((Math.ceil(this.position_x / 7.5) * 7.5) / 7.5) % 2 == 0) {
            this.position_x = Math.ceil(this.position_x / 7.5) * 7.5 + 7.5
          } else {
            this.position_x = Math.ceil(this.position_x / 7.5) * 7.5
          }
        }

        // REMINDER(IMPORTANT) - Debounce this!!! The lag and preformance is unacceptable.
        this.value = document.getElementById("weight-input-value").value
        this.updateWeight()
      }
    },
    updateWeight() {
      let weightval = document.getElementById("weight-input-value").value
      if (weightval > this.maxkg) {
        alert("Pet weight must be below 155 kg.")
        weightval = 155
        this.value = 155
        this.translateval = Math.round(-138 * this.value) + 320
        this.position_x = this.translateval
      }
      if (weightval < 0.1) {
        alert("Pet weight must be alove 0.1 kg")
        weightval = 0.1
        this.value = weightval
        this.translateval = Math.round(-138 * this.value) + 320
        this.position_x = this.translateval
      } else {
        this.value = weightval
        this.translateval = Math.round(-138 * this.value) + 320
        this.position_x = this.translateval
        weightval = this.value
      }
      this.$emit("input", this.value)
    },
  },
}
</script>

<style scoped>
.fl-sym-weight-input-container {
  overflow: hidden;
  height: 250px;
  margin-bottom: 1.75rem;
}
.fl-sym-weight-input {
  width: max-content;
}
.fl-sym-weight-input-bar {
  background: #d0dada;
}
.fl-sym-weight-input-bar:nth-child(10n) {
  background: #707070;
}
.number {
  position: absolute;
  right: 9px;
  bottom: 0;
  transform: translateX(-50%);
}
.fl-sym-indicator {
  position: absolute;
  top: 50px;
  left: 50%;
  z-index: 10;
  height: 98px;
}
.dot {
  height: 10px;
  width: 12px;
  background-color: #53d5e6;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  bottom: 49px;
  left: 2px;
}
.white-left {
  display: block;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 20%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 12em;
  height: 300px;
  position: relative;
  top: -200px;
}
.white-right {
  display: block;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 80%
  );
  width: 12em;
  height: 300px;
  position: relative;
  top: -500px;
  float: right;
}
form {
  text-align: center;
}
input#weight-input-value[data-v-185d6864] {
  font-size: 34px;
  font-weight: 800;
  width: 120px;
  text-align: right;
  outline: none;
}
.weight-measurement {
  font-size: 24px;
}
@media screen and (max-width: 630px) {
  .weight {
    margin-left: -2em;
  }
}
@media screen and (max-width: 580px) {
  .weight {
    margin-left: -3.5em;
  }
}
@media screen and (max-width: 530px) {
  .weight {
    margin-left: -4.5em;
  }
}
@media screen and (max-width: 480px) {
  .weight {
    margin-left: -6em;
  }
  .white-right,
  .white-left {
    width: 11em;
  }
}
@media screen and (max-width: 430px) {
  .weight {
    margin-left: -7.5em;
  }
}
@media screen and (max-width: 380px) {
  .weight {
    margin-left: -9.5em;
  }
}
@media screen and (max-width: 330px) {
  .weight {
    margin-left: -10em;
  }
}
@media screen and (max-width: 280px) {
  .weight {
    margin-left: -12.5em;
  }
}
</style>
